/**
 * CoPilotSidebarContext - CoPilot sidebar state management
 */

import { createContext, ReactNode, useCallback, useContext, useMemo, useState } from 'react';

interface ICoPilotSidebarContextProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  toggle: () => void;
}

const CoPilotSidebarContext = createContext<ICoPilotSidebarContextProps | undefined>(undefined);

export function CoPilotSidebarProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = useCallback(() => setIsOpen((prev) => !prev), []);

  const value = useMemo(() => ({ isOpen, setIsOpen, toggle }), [isOpen, toggle]);

  return <CoPilotSidebarContext.Provider value={value}>{children}</CoPilotSidebarContext.Provider>;
}

export function useCoPilotSidebar(): ICoPilotSidebarContextProps {
  const context = useContext(CoPilotSidebarContext);
  if (context === undefined) {
    throw new Error('useCoPilotSidebar must be used within CoPilotSidebarProvider');
  }
  return context;
}
